import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ScrEnvironment } from "src/environments/environment";
import { ScrBaseService } from "./base.service";
import { CacheService } from "./cache.service";
import { ScrServiceManager } from "./servicemanager.service";
import { BADGECOUNTS } from '../shared/constants';
import { Observable, of } from "rxjs";
import { tap, map } from 'rxjs/operators';
import { BadgeCountResponse, BadgeData } from "../models/badge.model";
import { WithCredNoCache } from "./authentication.service";


@Injectable({
  providedIn: 'root'
})
export class BadgeService extends ScrBaseService {

  constructor(
    serviceManager: ScrServiceManager,
    private environment: ScrEnvironment,
    private cache: CacheService,
    private http: HttpClient) {
    super(serviceManager);

  }

  public initBadgeData(data: BadgeData) {
    this.doSums(data);
    this.cache.set(BADGECOUNTS, data);
  }

  public updateLocally(fct: (data: BadgeData) => undefined|BadgeData) {
    this.getBadges(false).toPromise().then(data => {
      if (data) {
        const updated = fct(data);
        if (updated) {
          this.doSums(updated);
          this.cache.set(BADGECOUNTS, updated);
        }
      }
    });
  }
  getBadges(clearcache = false): Observable<BadgeData> {
    if (clearcache) {
      this.cache.invalidate(BADGECOUNTS, false);
    }

    const data = this.cache.get<BadgeData>(BADGECOUNTS);
    if (data) {
      return of(data);
    }

    return this.nobusy<BadgeData>(() => {
      const url = `${this.environment.base}/secure/common/badgecounts`;
      return this.http.get<BadgeCountResponse>(url, WithCredNoCache)
        .pipe(tap(rsp => {
        if ((rsp.status === 'success') && (rsp.data)) {
          this.doSums(rsp.data);
          this.cache.set(BADGECOUNTS, rsp.data, Number.MAX_SAFE_INTEGER);
        }
      }), map(rsp => rsp.data));
    });
  }

  private doSums(data: BadgeData) {
    data.shortCodeCount = data.needsActionCount + data.transfersCount + data.monthlyInvoiceCount;
    data.orderCount = data.needsPaymentCount + data.monthlyInvoiceCount;
    data.partnerCount = (data.contentProviderCount ?? 0) + (data.brandCount ?? 0);
  }
}
